import { Anagraphic, User } from 'src/models/user.model';

export const defaultUser: User = {
  id: 0,
  password: '',
  email: '',
  active: false,
  registrationDate: '',
  passwordUpdateDate: '',
  authority: {
    id: 0,
    name: '',
    capabilities: [],
  },
};

export const defaultAnagraphic: Anagraphic = {
  id: 0,
  firstname: '',
  lastname: '',
  birthDate: '',
  birthPlace: '',
  sex: 'M',
  fiscalCode: '',
  email: '',
  phoneNumber: '',
  note: '',
};
